import { render } from "./SpecificationView.vue?vue&type=template&id=885c3d94"
import script from "./SpecificationView.vue?vue&type=script&lang=js"
export * from "./SpecificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__